module.exports = __webpack_public_path__ + "static/media/taxi-stripe.f7c0d126.jpg";